import { render, staticRenderFns } from "./LeaveDuration.vue?vue&type=template&id=5e4d6168"
import script from "./LeaveDuration.vue?vue&type=script&lang=js"
export * from "./LeaveDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports